export default api => ({
  getInfo: () => api.get('/killswitches'),
  update: (data) => api.patch('/killswitches', data)
})
